/**
 * ============================================================
 * SINGLE PLACE TO CONFIGURE THE ASSESSMENT
 * ------------------------------------------------------------
 * Everything a deploying developer needs to change lives here.
 * No URL, endpoint, or brand string is hard-coded anywhere else.
 * ============================================================
 */

export const siteConfig = {
  /** Dr. Conkright's main WordPress site. */
  mainSiteUrl: 'https://scottconkright.com',

  /** The Relational Archetypes landing page on the main site. */
  archetypesPageUrl: 'https://scottconkright.com/relational-archetypes',

  /** Public URL this assessment will be hosted at. Used for share text + card footer. */
  assessmentUrl: 'https://assessment.scottconkright.com',

  /**
   * The existing "Free Guide to Your Archetype" PDF.
   * Swap this one string to point the CTA anywhere (main site, CDN, Dropbox...).
   */
  guidePdfUrl: 'https://scottconkright.com/relational-archetypes-guide.pdf',

  /** Brand strings shown in the header, the share card, and the printable results. */
  brand: {
    practitioner: 'Dr. Scott Conkright',
    practice: 'Meaningful Happiness',
    program: 'Relational Archetypes',
    theory: 'Affect Relational Theory (A.R.T.)',
    displayDomain: 'scottconkright.com',
  },

  /**
   * Mailchimp JSONP endpoint.
   * Take the `action` URL from your Mailchimp embedded form and change
   * `/subscribe/post` to `/subscribe/post-json`.
   *
   * Custom audience fields expected: PRIMARY, SECONDARY (both text).
   * Set to an empty string to disable the subscribe call entirely
   * (the user still receives their results).
   */
  mailchimpEndpoint:
    'https://scottconkright.us4.list-manage.com/subscribe/post-json?u=7537b69ebee1af57aafa53f95&id=e9231e2d3a&f_id=00ef23eaf0',
} as const
